/**
 * GENERAL
 */
export const MAX_FILE_SIZE = 50000000

export const MAX_CHUNK_SIZE = 100 * 1024 * 1024

export const MeetingLengths = [
  { value: 15, displayName: '15 min' },
  { value: 30, displayName: '30 min' },
  { value: 1 * 60, displayName: '1 hour' },
  { value: 1.5 * 60, displayName: '1.5 hours' },
  { value: 2 * 60, displayName: '2 hours' },
  { value: 2.5 * 60, displayName: '2.5 hours' },
  { value: 3 * 60, displayName: '3 hours' },
  { value: 3.5 * 60, displayName: '3.5 hours' },
  { value: 4 * 60, displayName: '4 hours' },
]

export const ALL_DAY_MEETING_LENGTH = 24 * 60

export const MESSAGES = {
  hardDependenciesTooltipCompassPath:
    'User will be restricted to Compass view and will only see tasks for which they’re the assignee, a participant, or an attendee. All email communication will be restricted to only emails that apply to those tasks',
  hardDependenciesTooltip:
    'User will be restricted to only their "My Task View" within app. All email communication will also be restricted to only emails that apply to tasks they they\'ve been assigned to.',
  tryAgain: 'Whoops! Something went wrong. Please try again.',
  restrictedNote: `Public notes are only permitted on "Visible" tasks`,
  experienceOverviewPlaceholder:
    'Experience overview details here, you can also use the "merge tag" "{PROJECT_MANAGER}" "{PROJECT_MANAGER_CALENDAR_LINK}" "PROJECT_MANAGER_MEETING_LINK".',
  experienceOverviewTooltip:
    'When Customers / Project team members are invited to a project, this is the invitation language that they will see in your invitation email. Be sure there are clear "Call to Actions" to encourage engagement and participation. Example: "Welcome... we are excited to get to work! We will use this project to keep track of all tasks, documentation, and deadlines necessary to have a successful implementation. Be sure to login and register..."',
  taskWithDependencyTooltip:
    'This task has a dependency. In order to edit the start date of this task, please remove the dependency.',
  visibilityDisabledMessage1:
    'You can only change external visibility on regular tasks after creation. Try selecting only regular tasks.',
  visibilityDisabledMessage2:
    'You can only change external visibility on internal regular tasks. Try selecting an internal assignee.',
  assigneeDisabledMessage:
    'You can only update the assignee if the responsibility is the same on all tasks. Try selecting a new responsibility.',
  priorityDisabledMessage:
    'Priority can only be edited on regular tasks. Try selecting only regular tasks.',
  customFieldTooltip: `Project Info Fields are used to add custom information to projects
    created in GUIDEcx. These custom fields can also be used as merge tags
    allowing you to dynamically add information per project to all the
    locations in the app that use merge tags.`,
  removeMergeTagWarn: `This custom field is currently being used as a merge
    tag. By removing this merge tag, all instances where
    this is being used in tasks and project descriptions
    will be removed. Are you sure?`,
  mergeTagDescription:
    'Merge tags allow you to inject dynamic attributes into the text.',
  exportCsvMessage: `We are processing your file and this may take a few minutes depending on the size of the list. Once complete, we'll email you the export.`,
  pmNoteFormHelper:
    'This note appears at the top of your project overview emails sent to projects team members that is by default sent every monday morning.',
  eventTooltip:
    "Event Information is emailed with your meeting invite.  It's most often used to add additional meeting information (e.g. screen share link, conference bridge, or location...).",
  compassViewTooltip:
    'A streamlined view that displays only tasks where that user is the assignee, a participant, or an attendee.',
  myTasksViewTooltip:
    'User will be restricted to "My Tasks" within the app. All email communication will be restricted to only emails that apply to assigned tasks.',
  fullViewTooltip:
    'User will have full access to all GUIDEcx features. Customers in this view can only see what has been enabled by the provider.',
}

export const SORT_INCREMENTOR = 65536

export const REJECT_EXTENSIONS = [
  '.svg',
  '.html',
  '.js',
  '.css',
  '.exe',
  '.sh',
  '.dll',
  '.cmd',
  '.dmg',
]
export const FILE_FORMATS_TO_DOWNLOAD = ['csv', 'xls', 'xlsx', 'jpg', 'png']

export const NOTES_ATTACHMENTS_FOLDER = 'notes/direct-uploads'
export const PROJECT_ATTACHMENTS_FOLDER = 'projects/direct-uploads'
export const TEMPLATE_ATTACHMENTS_FOLDER = 'templates/direct-uploads'
export const MILESTONE_ATTACHMENTS_FOLDER = 'milestones/direct-uploads'
